export enum ResidencePermit {
    PermanentResidencePermitC = 'PermanentResidencePermitC',
    ResidencePermitB = 'ResidencePermitB',
    AsylumSeekersN = 'AsylumSeekersN',
    ProvisionallyAdmittedForeigner = 'ProvisionallyAdmittedForeigner',
    ShortTermResidencePermitL = 'ShortTermResidencePermitL',
    PeopleInNeedOfProtectionS = 'PeopleInNeedOfProtectionS',
    CrossBorderCommuterG = 'CrossBorderCommuterG'
}
